import React, { useRef, useState } from 'react';

import Portal, { IPortal } from '../components/Portal/Portal';

export function useModalToggle() {
  const [isOpen, setOpen] = useState<boolean>(false);
  const ref = useRef<any>(null);

  const PartiallyAppliedPortal = ({
    children,
    domNode,
    background,
    scrollLock,
    focusLock,
    scrollIsolation,
    onClose,
  }: Pick<
    IPortal,
    | 'children'
    | 'domNode'
    | 'background'
    | 'scrollLock'
    | 'focusLock'
    | 'scrollIsolation'
    | 'onClose'
  >) => (
    <Portal
      setOpen={setOpen}
      domNode={domNode}
      background={background}
      scrollLock={scrollLock}
      focusLock={focusLock}
      scrollIsolation={scrollIsolation}
      onClose={onClose}
    >
      {children}
    </Portal>
  );

  return {
    isOpen,
    setOpen,
    ref,
    Portal: PartiallyAppliedPortal,
  };
}
